/* eslint-disable unicorn/new-for-builtins */
import dateTime from 'system/libs/dateTime';

define((require, exports, module) => {
    'use strict';

    const xPageId = require('xPageId');
    const uploadRadar = require('./uploadRadar');
    const UploadReason = require('./UploadReason');

    /**
     * @constructor
     * @param {string} type
     * @param {Object} data
     * @param {number} [level] – overrides log level for important data
     */
    function UploadLogRecord(type, data, level) {
        if (
            type !== UploadLogRecord.TYPE_INFO &&
            type !== UploadLogRecord.TYPE_FAIL &&
            type !== UploadLogRecord.TYPE_ERROR
        ) {
            throw new TypeError(UploadLogRecord.ERROR_NO_TYPE);
        }

        if (Object(data) !== data) {
            throw new TypeError(UploadLogRecord.ERROR_NO_DATA);
        }

        this.type = type;
        this.data = data;
        this.timeStamp = Date.now();

        if (level === undefined) {
            this.level = UploadLogRecord[type];
        } else if (level !== 0 && level !== 1 && level !== 2) {
            throw new TypeError(UploadLogRecord.WRONG_LEVEL);
        } else {
            this.level = level;
        }
    }

    Object.assign(UploadLogRecord, {
        ERROR_NO_TYPE: 'The type is not one of "info", "fail" or "error"',
        ERROR_NO_DATA: 'The data may only be an Object',
        WRONG_LEVEL: 'The level may only be 0, 1 or 2',

        TYPE_INFO: 'info',
        TYPE_FAIL: 'fail',
        TYPE_ERROR: 'error',

        // Уровни логирования
        LEVEL_IMPORTANT: 0,
        info: 2,
        fail: 1,
        error: 0,
    });

    UploadLogRecord.prototype = {
        constructor: UploadLogRecord,

        /**
         * @type {string}
         */
        type: 'abstract',

        /**
         * @type {string}
         */
        radarName: '',

        /**
         * @type {any}
         */
        radarValue: undefined,

        /**
         * @type {Object}
         */
        data: null,

        /**
         * @type {number}
         */
        timeStamp: -1,

        /**
         * @type {boolean}
         */
        isUnsent: true,

        /**
         * @type {number}
         */
        level: -1,

        /**
         * @type {string}
         */
        timePattern: 'hh:ss:mm.SSS(z)',

        /**
         * @type {string}
         */
        toStringPattern: '{TYPE} {DETAILS}',

        toString() {
            const data = this.data;
            let details;

            if (data instanceof UploadReason) {
                details = data.toLogString();
            } else {
                details = this.getDetails();

                const time = dateTime.format(
                    details.timeStamp,
                    this.timePattern,
                );

                details.timeStamp = undefined;
                details = '[' + time + '] ' + JSON.stringify(details);
            }

            let result = this.toStringPattern;

            result = result.replace('{TYPE}', this.type);
            result = result.replace('{DETAILS}', details);

            return result;
        },

        toLogString() {
            return this.toString();
        },

        /**
         * @returns {Object}
         */
        getDetails() {
            const data = this.data;
            let details;

            if (data instanceof UploadReason) {
                details = data.getDetails();
            } else {
                details = Object.assign({}, data);
                delete details.radarName;
                delete details.radarValue;
            }

            if (!details.timeStamp) {
                details.timeStamp = this.timeStamp;
            }

            details.pageId = xPageId;

            return details;
        },

        sendCounter() {
            const data = this.data;
            const counterName = data.radarName || this.radarName;

            if (counterName) {
                const counterValue = data.radarValue || this.radarValue;

                uploadRadar.sendCounter(counterName, counterValue);
            }
        },
    };

    module.exports = UploadLogRecord;
});
